import React from "react";

export function FreeUsersRestrictedText() {
	return (
		<div className="restricted">
			<p>
				Subscribe now to our ch-aviation News and overtake most other
				aviation professionals with your knowledge!
				<br />
				<br />
				Here’s what makes our News stand out:
			</p>

			<p>
				<b>Largest Dedicated News Desk Team</b>
			</p>
			<ul>
				<li>
					With the largest news desk in the industry, entirely
					self-funded, our dedicated full-time reporters are stationed
					across the globe, covering every time zone.
				</li>
			</ul>

			<p>
				<b>Exclusive Insights</b>
			</p>

			<ul>
				<li>
					{" "}
					Our reporters attend most major and regional aviation events
					and are in regular contact with C-level executives, bringing
					firsthand, exclusive stories directly to our readers.
				</li>
			</ul>

			<p>
				<b>Extensive Coverage</b>
			</p>

			<ul>
				<li>
					We cover all important topics, including in-depth CEO
					interviews, network developments, fleet transactions,
					investments, legal news, airport openings and closures,
					regulatory updates, financial difficulties, business models,
					aircraft management, geopolitical news, and more.
				</li>
			</ul>
			<p>
				<b>Integrated Knowledge Base</b>
			</p>

			<ul>
				<li>
					News articles are linked to our broader database,
					transforming news into searchable data and helping the
					industry make decisions.
				</li>
			</ul>
			<p>
				Learn more about ch-aviation News{" "}
				<a href="/products/operator-news">here</a>.
			</p>
		</div>
	);
}
